import crypt from "./crypt";
import { strtoInt } from "./libString";

const SESSAO_ATIVA = "sessaoAtiva";

const HandleAddLocationStorage = async (sessionData) => {
	if (sessionData.status === "CANCELADO") {
		clearSessionAndRedirectLogin();
		return;
	}

	localStorage.setItem(SESSAO_ATIVA, "1");
};

const temSessaoAtiva = () => localStorage.getItem(SESSAO_ATIVA) === "1";

const removerSessaoAtiva = () => localStorage.removeItem(SESSAO_ATIVA);

const HandleAddAppsLocationStorage = async (appsData) => {
	sessionStorage.setItem("sessionApps", JSON.stringify(appsData));
};

const getAppsLocationStorage = () => {
	try {
		const data = sessionStorage.getItem("sessionApps");
		return data ? JSON.parse(data) : [];
	} catch {
		return [];
	}
};

// Manter para compatibilidade temporária ou remover se migrado
const getSessionIDCollaborator = () => {
	if (!sessionStorage.getItem("sessionId")) return null;
	const decrypt = crypt(sessionStorage.getItem("sessionId"), "decrypt");

	const value = parseInt(decrypt);
	return value;
};

const getSessionUFandCity = async () => {
	const uf = sessionStorage.getItem("sessionUF");
	const city = await strtoInt(sessionStorage.getItem("sessionIdCidade"));
	return [uf, city];
};

const getSessionStatus = () => {
	if (!sessionStorage.getItem("sessionStatus")) return null;
	const sessionStatus = crypt(sessionStorage.getItem("sessionStatus"), "decrypt");
	const [status, diasRestantes] = sessionStatus.split(" - ");
	return { status, diasRestantes };
};

const deleteSession = (value) => {
	sessionStorage.removeItem(value);
};

const setSessionStatus = async (status) => {
	// removido lógica de persistência no disco
};

const setSessionUfAndCity = async (aUf, aCity) => {
	// removido lógica de persistência no disco
};

const clearSessionAndRedirectLogin = () => {
	removerSessaoAtiva();
	sessionStorage.clear();
	document.location = "/login";
};

export {
	HandleAddLocationStorage,
	HandleAddAppsLocationStorage,
	getSessionIDCollaborator,
	getSessionUFandCity,
	setSessionUfAndCity,
	getSessionStatus,
	setSessionStatus,
	deleteSession,
	getAppsLocationStorage,
	clearSessionAndRedirectLogin,
	temSessaoAtiva,
	removerSessaoAtiva,
};
